import {v4 as uuidv4} from 'uuid';

class User {

  constructor ({id, name, acronym, color, currentSituationID = undefined, role = 'visitor', cmsID, isCMSUser} = {}) {
    this.id = id ? id : uuidv4();
    Object.assign( this, { name, acronym, color, role, cmsID, isCMSUser } );
    this.currentSituationID = currentSituationID;
    this.rotation = undefined;
    this.position = undefined;
    this.gazePosition = undefined;
    this.cursorPosition = undefined;
    this.userIcon = undefined;
    this.resetShouldSync();
  }

  getType() { return "User"; }

  setShouldSync( fullSync ) { 
    if( fullSync ) {
      this.update = this.getSharedProperties();
    }
    this.shouldSync = true; 
    return this; 
  }

  resetShouldSync() { 
    this.shouldSync = false; 
    this.update = {
      id: this.id
    };
    return this; 
  }
  ifShouldSync() { return this.shouldSync; }

  // TODO: consider if this would be better as immutable property?
  setID (id) {
    this.id = id;
    this.update.id = id;
    return this;
  }

  setRotation (rotation) {
    //console.log("Setting user rotation " + JSON.stringify(rotation));
    this.rotation = rotation;
    this.update.rotation = rotation;
    return this;
  }

  setPosition (position) {
    this.position = position;
    this.update.position = position;
    return this;
  }

  setGazePosition (position) {
    this.gazePosition = position;
    this.update.gazePosition = position;
    return this;
  }

  setCursorPosition (position) {
    this.cursorPosition = position;
    this.update.cursorPosition = position;
    return this;
  }

  setName (value) {
    this.name = value;
    this.update.name = value;
    return this;
  }

  setCMSID( id ) {
    this.cmsID = id;
    return this;
  }

  setIsCMSUser( value ) {
    this.isCMSUser = value;
    return this;
  }

  setAcronym (value) {
    this.acronym = value;
    this.update.acronym = value;
    return this;
  }

  setUserIcon (value) {
    this.userIcon = value;
    return this;
  }

  setColor (value) {
    this.color = value;
    this.update.color = value;
    return this;
  }

  setRole( value ) {
    this.role = value;
    this.update.role = value;
    return this;
  }

  getID () {
    return this.id;
  }

  getRotation () {
    return this.rotation;
  }

  getPosition () {
    return this.position;
  }

  getGazePosition () {
    return this.gazePosition;
  }

  getCursorPosition () {
    return this.cursorPosition;
  }

  getName () {
    return this.name;
  }

  getAcronym () {
    return this.acronym;
  }

  getColor () {
    return this.color;
  }

  getRole() {
    return this.role;
  }

  getUserIcon(){
    return this.userIcon;
  }

  getCMSID() {
    return this.cmsID;
  }

  isCMSUSer() {
    return this.isCMSUSer;
  }

  setCurrentSituationID (id) {
    if (!Number.isInteger(id))
      id = parseInt(id);
    const oldSituation = this.currentSituationID;
    if( id !== this.currentSituationID ) {
      // console.log("User(" + this.id + "): Changing Situation ID from " + this.currentSituationID + " to " + id);
      this.currentSituationID = id;
      this.update.currentSituationID = id;
      this.shouldSync = true;
    }
    return oldSituation;
  }

  getCurrentSituationID () {
    return this.currentSituationID;
  }

  // Returns those properties that are supposed to be shared over the network
  getSharedProperties() {
    return {
      id: this.id,
      name: this.name,
      acronym: this.acronym,
      color: this.color,
      currentSituationID: this.currentSituationID,
      role: this.role,
      rotation: this.rotation,
      position: this.position,
      gazePosition: this.gazePosition,
      cursorPosition: this.cursorPosition
    }
  }

  getUpdatedProperties() {
    return this.update;
  }
}

export {User}
